<template>
  <v-app>
    <router-view v-if="appReady" />
    <SplashScreen v-else />
  </v-app>
</template>

<script>
import SplashScreen from '@/components/splash/SplashContainer'

export default {
  name: 'App',
  components: {
    SplashScreen
  },
  computed: {
    groupLoading () {
      return this.$store.state.User.groupLoading
    },
    appReady () {
      return this.$auth.inProgress === 'none' &&
        !this.groupLoading &&
        !!this.$store.state.User.user.extension_SystemID
    }
  },
  watch: {
    appReady (ready) {
      if (ready) {
        this.goLandingIfHome()
      }
    }
  },
  methods: {
    goLandingIfHome () {
      if (this.$route.name !== 'home') return
      const name = this.$store.getters['User/landingRouteName']
      if (name) {
        this.$router.replace({ name }).catch(() => {})
      }
    }
  }
}
</script>
